export const ACCESS_TOKEN = 'LOCAL@ACCESS_TOKEN'
export const LOGIN_USERNAME = 'LOCAL@LOGIN_USERNAME'
export const LOGIN_ROLEID = 'LOCAL@LOGIN_ROLEID'

export const SEARCH_FILTER_STORE = 'LOCAL@SEARCHFILTERSTORE'

export const THEME_STORE = 'LOCAL@THEMESTORE'
export const STORE_HEADER = 'LOCAL@STORE_HEADER'
export const STORE_HEADER_BUTTON = 'LOCAL@STORE_HEADER_BUTTON'